module.exports = __webpack_public_path__ + "static/img/liberal2.d567cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/role/liberal2.png
// module id = 75
// module chunks = 0